import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #004c7f;
  display: flex;
  justify-content: space-between;
  padding: 1rem;
  border-top-right-radius: 2rem 2rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const CommentContainerFirst = styled.div`
  background-color: rgb(235, 247, 237);
  border-radius: 10px;
  padding: 10px;
  margin: 0px 0 10px 0;
`;

export const CommentContainerSecond = styled.div`
  background-color: rgb(220, 240, 255);
  border-radius: 10px;
  padding: 10px;
  margin: 0px 0 10px 0;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 0 1.375rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column-reverse;
`;

export const OptionsWrapper = styled.div`
  padding: 1.375rem;
  padding-bottom: 0px0 2.5rem 1.375rem 1.375rem;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: 1.25rem;
  margin-bottom: 10px;
  position: relative;
`;

export const AuthorInfo = styled.span`
  justify-self: auto;
  color: #004c7f;
  font-size: 16px;
  font-weight: 700;
  display: block;
  text-align: ${(props) => props.textPosition};
`;

export const DateInfo = styled.span`
  justify-self: auto;
  color: #004c7f;
  font-size: 16px;
  font-weight: 400;
`;

export const AlignRight = styled.span`
  display: block;
  text-align: end;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 2.5rem 1.375rem 1.375rem;
  padding-top: 0px;
`;
